import { render, staticRenderFns } from "./RsSurveyForm.vue?vue&type=template&id=6f54e056&scoped=true"
import script from "./RsSurveyForm.vue?vue&type=script&lang=js"
export * from "./RsSurveyForm.vue?vue&type=script&lang=js"
import style0 from "./RsSurveyForm.vue?vue&type=style&index=0&id=6f54e056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54e056",
  null
  
)

export default component.exports